import React from 'react';
import HallDashboard from '../modules/hall/components/HallDashboard';

export default function HallPage() {
  return <HallDashboard />;
}
